import React from "react";
import { RotateCcw } from "lucide-react";
import ComingSoon from "./ComingSoon";

export default function AdminRefunds() {
    return (
        <ComingSoon
            title="Refunds"
            eyebrow="Payments"
            description="Review refund requests, approve full or partial refunds and trigger Stripe reversal. Audit trail for every decision."
            icon={RotateCcw}
            ctaLabel="View Stripe"
            accent="grape"
            columns={["Customer", "Course", "Amount", "Reason", "Requested", "Status"]}
            mockRows={[
                ["Cody Fisher", "OSINT for Security Operators", "£379.00", "Duplicate purchase", "10 Feb 2026", "Pending"],
                ["Robert Fox", "Defensive & Evasive Driving", "£599.00", "Schedule conflict", "08 Feb 2026", "Approved"],
                ["Wade Warren", "Travel Risk Management", "£189.50", "Partial — module not available", "01 Feb 2026", "Refunded"],
                ["Esther Howard", "ISO 27001 Lead Implementer", "£799.00", "Out of scope for role", "29 Jan 2026", "Declined"],
            ]}
        />
    );
}
